import OProjectNavOwner from './o-project-nav-owner.vue'

export default OProjectNavOwner
